export enum RoutesName {
    //main
    main = "/main",
    vdo = "/vdo",
    score = "/score",



}